/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as DashboardImport } from './routes/_dashboard'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as DashboardUsersImport } from './routes/_dashboard/users'
import { Route as DashboardSupportImport } from './routes/_dashboard/support'
import { Route as DashboardOrdersImport } from './routes/_dashboard/orders'
import { Route as DashboardIntegrationImport } from './routes/_dashboard/integration'
import { Route as DashboardDriversImport } from './routes/_dashboard/drivers'
import { Route as DashboardStatsLayoutImport } from './routes/_dashboard/_stats-layout'
import { Route as AuthSetPasswordImport } from './routes/_auth/set-password'
import { Route as AuthResetPasswordImport } from './routes/_auth/reset-password'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as DashboardRecruitmentIndexImport } from './routes/_dashboard/recruitment/index'
import { Route as DashboardRequestsIdImport } from './routes/_dashboard/requests/$id'
import { Route as DashboardRecruitmentCreateImport } from './routes/_dashboard/recruitment/create'
import { Route as DashboardStatsLayoutStatsIndexImport } from './routes/_dashboard/_stats-layout/stats/index'
import { Route as DashboardStatsLayoutStatsByDriversImport } from './routes/_dashboard/_stats-layout/stats/by-drivers'
import { Route as DashboardStatsLayoutStatsByDateImport } from './routes/_dashboard/_stats-layout/stats/by-date'

// Create/Update Routes

const DashboardRoute = DashboardImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardUsersRoute = DashboardUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardSupportRoute = DashboardSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardOrdersRoute = DashboardOrdersImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardIntegrationRoute = DashboardIntegrationImport.update({
  id: '/integration',
  path: '/integration',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardDriversRoute = DashboardDriversImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardStatsLayoutRoute = DashboardStatsLayoutImport.update({
  id: '/_stats-layout',
  getParentRoute: () => DashboardRoute,
} as any)

const AuthSetPasswordRoute = AuthSetPasswordImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const DashboardRecruitmentIndexRoute = DashboardRecruitmentIndexImport.update({
  id: '/recruitment/',
  path: '/recruitment/',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardRequestsIdRoute = DashboardRequestsIdImport.update({
  id: '/requests/$id',
  path: '/requests/$id',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardRecruitmentCreateRoute = DashboardRecruitmentCreateImport.update(
  {
    id: '/recruitment/create',
    path: '/recruitment/create',
    getParentRoute: () => DashboardRoute,
  } as any,
)

const DashboardStatsLayoutStatsIndexRoute =
  DashboardStatsLayoutStatsIndexImport.update({
    id: '/stats/',
    path: '/stats/',
    getParentRoute: () => DashboardStatsLayoutRoute,
  } as any)

const DashboardStatsLayoutStatsByDriversRoute =
  DashboardStatsLayoutStatsByDriversImport.update({
    id: '/stats/by-drivers',
    path: '/stats/by-drivers',
    getParentRoute: () => DashboardStatsLayoutRoute,
  } as any)

const DashboardStatsLayoutStatsByDateRoute =
  DashboardStatsLayoutStatsByDateImport.update({
    id: '/stats/by-date',
    path: '/stats/by-date',
    getParentRoute: () => DashboardStatsLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_auth/set-password': {
      id: '/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthSetPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_dashboard/_stats-layout': {
      id: '/_dashboard/_stats-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardStatsLayoutImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/drivers': {
      id: '/_dashboard/drivers'
      path: '/drivers'
      fullPath: '/drivers'
      preLoaderRoute: typeof DashboardDriversImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/integration': {
      id: '/_dashboard/integration'
      path: '/integration'
      fullPath: '/integration'
      preLoaderRoute: typeof DashboardIntegrationImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/orders': {
      id: '/_dashboard/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof DashboardOrdersImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/support': {
      id: '/_dashboard/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof DashboardSupportImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/users': {
      id: '/_dashboard/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof DashboardUsersImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/recruitment/create': {
      id: '/_dashboard/recruitment/create'
      path: '/recruitment/create'
      fullPath: '/recruitment/create'
      preLoaderRoute: typeof DashboardRecruitmentCreateImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/requests/$id': {
      id: '/_dashboard/requests/$id'
      path: '/requests/$id'
      fullPath: '/requests/$id'
      preLoaderRoute: typeof DashboardRequestsIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/recruitment/': {
      id: '/_dashboard/recruitment/'
      path: '/recruitment'
      fullPath: '/recruitment'
      preLoaderRoute: typeof DashboardRecruitmentIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/_stats-layout/stats/by-date': {
      id: '/_dashboard/_stats-layout/stats/by-date'
      path: '/stats/by-date'
      fullPath: '/stats/by-date'
      preLoaderRoute: typeof DashboardStatsLayoutStatsByDateImport
      parentRoute: typeof DashboardStatsLayoutImport
    }
    '/_dashboard/_stats-layout/stats/by-drivers': {
      id: '/_dashboard/_stats-layout/stats/by-drivers'
      path: '/stats/by-drivers'
      fullPath: '/stats/by-drivers'
      preLoaderRoute: typeof DashboardStatsLayoutStatsByDriversImport
      parentRoute: typeof DashboardStatsLayoutImport
    }
    '/_dashboard/_stats-layout/stats/': {
      id: '/_dashboard/_stats-layout/stats/'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof DashboardStatsLayoutStatsIndexImport
      parentRoute: typeof DashboardStatsLayoutImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardStatsLayoutRouteChildren {
  DashboardStatsLayoutStatsByDateRoute: typeof DashboardStatsLayoutStatsByDateRoute
  DashboardStatsLayoutStatsByDriversRoute: typeof DashboardStatsLayoutStatsByDriversRoute
  DashboardStatsLayoutStatsIndexRoute: typeof DashboardStatsLayoutStatsIndexRoute
}

const DashboardStatsLayoutRouteChildren: DashboardStatsLayoutRouteChildren = {
  DashboardStatsLayoutStatsByDateRoute: DashboardStatsLayoutStatsByDateRoute,
  DashboardStatsLayoutStatsByDriversRoute:
    DashboardStatsLayoutStatsByDriversRoute,
  DashboardStatsLayoutStatsIndexRoute: DashboardStatsLayoutStatsIndexRoute,
}

const DashboardStatsLayoutRouteWithChildren =
  DashboardStatsLayoutRoute._addFileChildren(DashboardStatsLayoutRouteChildren)

interface DashboardRouteChildren {
  DashboardStatsLayoutRoute: typeof DashboardStatsLayoutRouteWithChildren
  DashboardDriversRoute: typeof DashboardDriversRoute
  DashboardIntegrationRoute: typeof DashboardIntegrationRoute
  DashboardOrdersRoute: typeof DashboardOrdersRoute
  DashboardSupportRoute: typeof DashboardSupportRoute
  DashboardUsersRoute: typeof DashboardUsersRoute
  DashboardRecruitmentCreateRoute: typeof DashboardRecruitmentCreateRoute
  DashboardRequestsIdRoute: typeof DashboardRequestsIdRoute
  DashboardRecruitmentIndexRoute: typeof DashboardRecruitmentIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardStatsLayoutRoute: DashboardStatsLayoutRouteWithChildren,
  DashboardDriversRoute: DashboardDriversRoute,
  DashboardIntegrationRoute: DashboardIntegrationRoute,
  DashboardOrdersRoute: DashboardOrdersRoute,
  DashboardSupportRoute: DashboardSupportRoute,
  DashboardUsersRoute: DashboardUsersRoute,
  DashboardRecruitmentCreateRoute: DashboardRecruitmentCreateRoute,
  DashboardRequestsIdRoute: DashboardRequestsIdRoute,
  DashboardRecruitmentIndexRoute: DashboardRecruitmentIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof DashboardStatsLayoutRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/drivers': typeof DashboardDriversRoute
  '/integration': typeof DashboardIntegrationRoute
  '/orders': typeof DashboardOrdersRoute
  '/support': typeof DashboardSupportRoute
  '/users': typeof DashboardUsersRoute
  '/recruitment/create': typeof DashboardRecruitmentCreateRoute
  '/requests/$id': typeof DashboardRequestsIdRoute
  '/recruitment': typeof DashboardRecruitmentIndexRoute
  '/stats/by-date': typeof DashboardStatsLayoutStatsByDateRoute
  '/stats/by-drivers': typeof DashboardStatsLayoutStatsByDriversRoute
  '/stats': typeof DashboardStatsLayoutStatsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof DashboardStatsLayoutRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/drivers': typeof DashboardDriversRoute
  '/integration': typeof DashboardIntegrationRoute
  '/orders': typeof DashboardOrdersRoute
  '/support': typeof DashboardSupportRoute
  '/users': typeof DashboardUsersRoute
  '/recruitment/create': typeof DashboardRecruitmentCreateRoute
  '/requests/$id': typeof DashboardRequestsIdRoute
  '/recruitment': typeof DashboardRecruitmentIndexRoute
  '/stats/by-date': typeof DashboardStatsLayoutStatsByDateRoute
  '/stats/by-drivers': typeof DashboardStatsLayoutStatsByDriversRoute
  '/stats': typeof DashboardStatsLayoutStatsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/set-password': typeof AuthSetPasswordRoute
  '/_dashboard/_stats-layout': typeof DashboardStatsLayoutRouteWithChildren
  '/_dashboard/drivers': typeof DashboardDriversRoute
  '/_dashboard/integration': typeof DashboardIntegrationRoute
  '/_dashboard/orders': typeof DashboardOrdersRoute
  '/_dashboard/support': typeof DashboardSupportRoute
  '/_dashboard/users': typeof DashboardUsersRoute
  '/_dashboard/recruitment/create': typeof DashboardRecruitmentCreateRoute
  '/_dashboard/requests/$id': typeof DashboardRequestsIdRoute
  '/_dashboard/recruitment/': typeof DashboardRecruitmentIndexRoute
  '/_dashboard/_stats-layout/stats/by-date': typeof DashboardStatsLayoutStatsByDateRoute
  '/_dashboard/_stats-layout/stats/by-drivers': typeof DashboardStatsLayoutStatsByDriversRoute
  '/_dashboard/_stats-layout/stats/': typeof DashboardStatsLayoutStatsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/drivers'
    | '/integration'
    | '/orders'
    | '/support'
    | '/users'
    | '/recruitment/create'
    | '/requests/$id'
    | '/recruitment'
    | '/stats/by-date'
    | '/stats/by-drivers'
    | '/stats'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/drivers'
    | '/integration'
    | '/orders'
    | '/support'
    | '/users'
    | '/recruitment/create'
    | '/requests/$id'
    | '/recruitment'
    | '/stats/by-date'
    | '/stats/by-drivers'
    | '/stats'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_dashboard'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/set-password'
    | '/_dashboard/_stats-layout'
    | '/_dashboard/drivers'
    | '/_dashboard/integration'
    | '/_dashboard/orders'
    | '/_dashboard/support'
    | '/_dashboard/users'
    | '/_dashboard/recruitment/create'
    | '/_dashboard/requests/$id'
    | '/_dashboard/recruitment/'
    | '/_dashboard/_stats-layout/stats/by-date'
    | '/_dashboard/_stats-layout/stats/by-drivers'
    | '/_dashboard/_stats-layout/stats/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/_dashboard"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login",
        "/_auth/reset-password",
        "/_auth/set-password"
      ]
    },
    "/_dashboard": {
      "filePath": "_dashboard.tsx",
      "children": [
        "/_dashboard/_stats-layout",
        "/_dashboard/drivers",
        "/_dashboard/integration",
        "/_dashboard/orders",
        "/_dashboard/support",
        "/_dashboard/users",
        "/_dashboard/recruitment/create",
        "/_dashboard/requests/$id",
        "/_dashboard/recruitment/"
      ]
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_auth/reset-password": {
      "filePath": "_auth/reset-password.tsx",
      "parent": "/_auth"
    },
    "/_auth/set-password": {
      "filePath": "_auth/set-password.tsx",
      "parent": "/_auth"
    },
    "/_dashboard/_stats-layout": {
      "filePath": "_dashboard/_stats-layout.tsx",
      "parent": "/_dashboard",
      "children": [
        "/_dashboard/_stats-layout/stats/by-date",
        "/_dashboard/_stats-layout/stats/by-drivers",
        "/_dashboard/_stats-layout/stats/"
      ]
    },
    "/_dashboard/drivers": {
      "filePath": "_dashboard/drivers.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/integration": {
      "filePath": "_dashboard/integration.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/orders": {
      "filePath": "_dashboard/orders.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/support": {
      "filePath": "_dashboard/support.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/users": {
      "filePath": "_dashboard/users.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/recruitment/create": {
      "filePath": "_dashboard/recruitment/create.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/requests/$id": {
      "filePath": "_dashboard/requests/$id.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/recruitment/": {
      "filePath": "_dashboard/recruitment/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/_stats-layout/stats/by-date": {
      "filePath": "_dashboard/_stats-layout/stats/by-date.tsx",
      "parent": "/_dashboard/_stats-layout"
    },
    "/_dashboard/_stats-layout/stats/by-drivers": {
      "filePath": "_dashboard/_stats-layout/stats/by-drivers.tsx",
      "parent": "/_dashboard/_stats-layout"
    },
    "/_dashboard/_stats-layout/stats/": {
      "filePath": "_dashboard/_stats-layout/stats/index.tsx",
      "parent": "/_dashboard/_stats-layout"
    }
  }
}
ROUTE_MANIFEST_END */
